const SemVerGte = require('semver/functions/gte')
const SemVerLte = require('semver/functions/lte')
const SemVerSatisfies = require('semver/functions/satisfies')
const {
  fields: deviceSettingsConfig
} = require('cloud-utils/config/device-settings/default-v2.json')
const {
  isValidStringForRecordingEncryptionKey
} = require('cloud-utils/helpers/validations')
const {
  NEW_RECORDING_ENCRYPTION_SUPPORT_VERSION_RANGE
} = require('../constants/devices/deviceVersions')

const mqttSupportFrom = '5.0.0'
const filterOutDIFields = [
  'driverPrompt',
  'audioAlert',
  'driverPromptDurationSeconds'
]
const deviceUISettings = JSON.parse(
  JSON.stringify(
    deviceSettingsConfig.filter(
      setting => setting.configure.allowInUI !== false
    )
  )
)
const fields = JSON.parse(
  JSON.stringify(
    deviceUISettings.filter(
      s => !['pinCodeDi', 'qrDi', ...filterOutDIFields].includes(s.name)
    )
  )
)
fields.push(
  {
    id: 15,
    name: 'driverIdentification',
    title: 'Driver Identification',
    translateTitle: 'driverIdentification',
    valueType: 'select',
    allowedValues: [
      {
        title: 'Off',
        value: 'off'
      },
      {
        title: 'QR',
        value: 'qr'
      },
      {
        title: 'Pin',
        value: 'pin'
      }
    ],
    defaultValue: 'off',
    defaultLockedStatus: false,
    configure: {
      setConfig: true,
      allowInBulk: true
    },
    fromVersion: '3.12.0'
  },
  ...deviceUISettings.filter(item => filterOutDIFields.includes(item.name))
)
fields.forEach(f => {
  f.valueFieldName = f.valueFieldName || 'value'
})
angular
  .module('surfsightApp.controllers')
  .controller('DeviceUiSettingsEditController', [
    '$scope',
    '$rootScope',
    '$filter',
    '$mdToast',
    '$localStorage',
    '$http',
    function ($scope, $root, $filter, $mdToast, $localStorage, $http) {
      const $translate = $filter('translate')
      $scope.config = {
        ...$scope.editConfig,
        submitLabel: 'save',
        cancelLabel: 'cancel'
      }
      $scope.organizationId = $root.currentUserOrganization.id
      $scope.pinManagementVisible = false
      $scope.isAuthorizedForPinManagement = false
      $scope.pinForm = {
        userPassword: '',
        adminPin: '',
        driverPin: ''
      }
      $scope.showPin = {
        adminPin: false,
        driverPin: false
      }
      $scope.isOrgAllDevicesAI12 = $localStorage.isOrgAllDevicesAI12 || false
      const userType = $localStorage.userDetails.type
      const partnerId =
        $localStorage.currentUserOrganization.reseller_id ||
        (userType === 'reseller' ||
        userType === 'sub-reseller' ||
        userType === 'reseller-contact'
          ? $localStorage.userDetails.id
          : null)
      // Check if recording encryption feature is enabled
      $scope.isRecordingEncryptionFeatureEnabled = false
      const featureFlagRequest = {
        method: 'POST',
        url: `${EDGE_BASEURL}/red-recording-encryption-feature`,
        data: {
          partnerId
        }
      }

      $http(featureFlagRequest)
        .then(featureFlagResponse => {
          $scope.isRecordingEncryptionFeatureEnabled =
            featureFlagResponse.data.enabled || false
          applyFeatureFlagLogic()
        })
        .catch(featureFlagError => {
          console.error(
            'Failed to check encryption feature flag:',
            featureFlagError
          )
          $scope.isRecordingEncryptionFeatureEnabled = false
          applyFeatureFlagLogic()
        })

      function applyFeatureFlagLogic () {
        if (
          $scope.isRecordingEncryptionFeatureEnabled &&
          ($scope.isOrgDeviceSettings || $scope.isBulkDevicesSelected)
        ) {
          $scope.uiSettingFields = $scope.uiSettingFields.filter(
            field => field.name !== 'recordingEncryption'
          ) // Remove recordingEncryption field from Bulk devices settings and via org profile
          console.log(
            '$scope.uiSettingFields after feature flag filter',
            $scope.uiSettingFields
          )
        }
      }
      $scope.customValueForStandby = 0
      $scope.areDevicesInActive =
        $scope.selectedBulkDevices && $scope.selectedBulkDevices.length
          ? $scope.selectedBulkDevices.every(i => i.status === 'offline')
          : false
      const supportFromVersion = fromVersion => {
        if (!fromVersion || !$scope.version) return true
        return SemVerGte($scope.version, fromVersion)
      }
      const supportToVersion = toVersion => {
        if (!toVersion || !$scope.version) return true
        return SemVerLte($scope.version, toVersion)
      }
      const supportVersionRanges = versionRanges => {
        if (!versionRanges || !$scope.version) return true
        return SemVerSatisfies($scope.version, versionRanges)
      }
      $scope.isMqttSupport = () => {
        if (!$scope.version) return false
        return SemVerGte($scope.version, mqttSupportFrom)
      }
      $scope.isGradedOut = name => {
        return (
          (name === 'inCabinCameraRecording' &&
            supportToVersion('3.9.49') &&
            (!$scope.uiSettings.driverCamera ||
              !$scope.uiSettings.driverCamera.value)) ||
          (name === 'driverPrompt' &&
            $scope.driverIdentificationSetting &&
            !['pin', 'qr'].includes(
              $scope.driverIdentificationSetting.value
            )) ||
          (name === 'audioAlert' &&
            !(
              $scope.driverIdentificationSetting &&
              ['pin', 'qr'].includes(
                $scope.driverIdentificationSetting.value
              ) &&
              $scope.uiSettings.driverPrompt &&
              $scope.uiSettings.driverPrompt.value
            ))
        )
      }
      $scope.isStandbyClosed = false
      $scope.preventClose = function (event) {
        if (event.keyCode === 13 || event.which === 13) {
          event.preventDefault()
        }
        if ($scope.isStandbyClosed) {
          event.stopPropagation()
        }
      }
      $scope.onCustomStandbyValueChange = function (uiSettingField) {
        const valueFieldName = uiSettingField.valueFieldName
        const rawValue = $scope.uiSettings.standby[valueFieldName]

        if (rawValue === undefined || rawValue === null || rawValue === '') {
          return
        }

        const value = Number(rawValue)

        if (value > $scope.maxValueForStandby || value <= 0) {
          $scope.uiSettings.standby[valueFieldName] = undefined
          return
        }

        if (!Number.isFinite(value)) {
          return
        }

        const customOption = uiSettingField.allowedValues.find(
          allowedValue => allowedValue.custom
        )
        if (customOption) {
          Object.assign(customOption, {
            title: value,
            value
          })
        } else {
          uiSettingField.allowedValues.push({
            title: value,
            value,
            custom: true
          })
        }
        $scope.customValueForStandby = value
      }
      $scope.setStandbyClosed = function () {
        $scope.isStandbyClosed = true
      }

      $scope.updateDependentFields = function (identifier) {
        return (
          (identifier === 'driverPrompt' || identifier === 'audioAlert') &&
          this.updateDependenciesForDI(identifier)
        )
      }
      $scope.updateDependenciesForDI = function (identifier) {
        if (identifier === 'driverPrompt') {
          $scope.uiSettings.audioAlert = {
            value:
              $scope.uiSettings.driverPrompt &&
              $scope.uiSettings.driverPrompt.value
          }
          if (
            $scope.uiSettings.driverPrompt &&
            $scope.uiSettings.driverPrompt.value
          ) {
            $scope.uiSettings.driverPromptDurationSeconds = {
              value: 30
            }
          } else {
            delete $scope.uiSettings.driverPromptDurationSeconds.value
          }
        } else if (identifier === 'driverIdentification') {
          if (
            $scope.driverIdentificationSetting &&
            $scope.driverIdentificationSetting.value === 'off'
          ) {
            $scope.uiSettings.driverPrompt = {
              value: false
            }
            $scope.uiSettings.audioAlert = {
              value: false
            }
            delete $scope.uiSettings.driverPromptDurationSeconds
          }
        }
      }
      function buildUiSettingFields () {
        $scope.uiSettingFields = JSON.parse(
          JSON.stringify(
            fields.filter(({ fromVersion, toVersion, versionRanges }) => {
              const noVersion = !$scope.version
              const fromVersionPass =
                !fromVersion || supportFromVersion(fromVersion)
              const toVersionPass = !toVersion || supportToVersion(toVersion)
              const versionRangesPass = supportVersionRanges(versionRanges)
              const result =
                noVersion ||
                (fromVersionPass && toVersionPass && versionRangesPass)
              return result
            })
          )
        ).filter(
          item =>
            !$scope.uiSettings[item.name] ||
            ($scope.uiSettings[item.name] &&
              $scope.uiSettings[item.name].allowInBulk)
        )
        if (!$scope.isOrgDeviceSettings) {
          $scope.uiSettingFields = $scope.uiSettingFields.filter(
            field => field.name !== 'hotspotEnabled'
          ) // Hiding hotspotEnabled parameter, since UI support not required for now (SUR-7308)
        }
        $scope.maxValueForStandby = $scope.uiSettingFields.find(
          uiSettingField => uiSettingField.name === 'standby'
        ).maxValue
        applyFeatureFlagLogic()
      }

      buildUiSettingFields()

      $scope.$watch('version', function (newVersion, oldVersion) {
        if (newVersion && newVersion !== oldVersion) {
          buildUiSettingFields()
        }
      })

      $scope.supportFromVersion = supportFromVersion
      $scope.supportToVersion = supportToVersion
      $scope.initialRecordingEncryptionSetting = null
      $scope.initialDriverIdentificationSetting = null
      $scope.driverIdentificationSetting = {
        value: 'off'
      }

      $scope.onValidateAndSubmit = () => {
        let invalidField
        const { recordingEncryption } = $scope.uiSettings
        fields.forEach(el => {
          if (
            (!invalidField && el.valueType === 'number') ||
            (el.valueType === 'select' && el.name === 'standby')
          ) {
            let isEmptyValueAllowed = false

            if (el.parentFieldName) {
              if (
                !$scope.uiSettings[el.parentFieldName] ||
                !$scope.uiSettings[el.parentFieldName][el.parentFieldValueName]
              ) {
                isEmptyValueAllowed = true
              }
            }

            if (isEmptyValueAllowed) {
              return
            }
            if (
              $scope.uiSettings[el.name] &&
              !$scope.uiSettings[el.name][el.valueFieldName]
            ) {
              return (invalidField = el.name)
            } else if (
              $scope.uiSettings[el.name] &&
              !Number.isInteger(+$scope.uiSettings[el.name][el.valueFieldName])
            ) {
              return (invalidField = el.name)
            }
          }
        })

        if ('hotspotEnabled' in $scope.uiSettings) {
          'hotSpot' in $scope.uiSettings &&
            ($scope.uiSettings['hotSpot'].hotspotEnabled =
              $scope.uiSettings.hotspotEnabled.value)
          delete $scope.uiSettings.hotspotEnabled
        }
        if (invalidField) {
          return $scope.showInvalidIntegerError($translate(invalidField))
        }
        if (
          !$scope.isRecordingEncryptionFeatureEnabled &&
          recordingEncryption &&
          recordingEncryption.enabled &&
          (recordingEncryption.password ||
            !$scope.initialRecordingEncryptionSetting.enabled)
        ) {
          const isNewEncryptionSupportedVersion = $scope.version
            ? SemVerSatisfies(
                $scope.version,
                NEW_RECORDING_ENCRYPTION_SUPPORT_VERSION_RANGE
              )
            : true // if bulk edit, version is not available
          if (
            !isNewEncryptionSupportedVersion &&
            !isValidStringForRecordingEncryptionKey(
              recordingEncryption.password,
              true
            )
          ) {
            return $scope.showMessageToast(
              $translate('insertValidOldRecordingEncryptionPassword')
            )
          }
          if (
            isNewEncryptionSupportedVersion &&
            !isValidStringForRecordingEncryptionKey(
              recordingEncryption.password,
              false
            )
          ) {
            return $scope.showMessageToast(
              $translate('insertValidRecordingEncryptionPassword')
            )
          }
        }
        delete $scope.uiSettings.adasConfig
        if ($scope.uiSettings.recordingEncryption) {
          Object.assign($scope.uiSettings.recordingEncryption, {
            password:
              (recordingEncryption &&
                recordingEncryption.enabled &&
                recordingEncryption.password) ||
              undefined
          })
        }

        if ($scope.uiSettings.wakeupMsg && $scope.uiSettings.wakeupMsgTimeout) {
          $scope.uiSettings.wakeupMsg = {
            enabled: $scope.uiSettings.wakeupMsg.enabled,
            timeout: $scope.uiSettings.wakeupMsgTimeout.timeout
          }
          delete $scope.uiSettings.wakeupMsgTimeout
        }
        let pinCodeDiValue = false
        let qrDiValue = false
        switch ($scope.driverIdentificationSetting.value) {
          case 'pin':
            pinCodeDiValue = true
            break
          case 'qr':
            qrDiValue = true
            break
        }
        if ($scope.uiSettings.pinCodeDi) {
          Object.assign($scope.uiSettings.pinCodeDi, {
            value: pinCodeDiValue
          })
        }
        if ($scope.uiSettings.qrDi) {
          Object.assign($scope.uiSettings.qrDi, {
            value: qrDiValue
          })
        }
        if (
          ($scope.uiSettings.pinCodeDi && $scope.uiSettings.pinCodeDi.value) ||
          ($scope.uiSettings.qrDi && $scope.uiSettings.qrDi.value)
        ) {
          Object.assign($scope.uiSettings, {
            driverIdentification: {
              driverPrompt:
                $scope.uiSettings.driverPrompt &&
                $scope.uiSettings.driverPrompt.value,
              audioAlert:
                $scope.uiSettings.audioAlert &&
                $scope.uiSettings.audioAlert.value,
              driverPromptDurationSeconds:
                $scope.uiSettings.driverPromptDurationSeconds &&
                $scope.uiSettings.driverPromptDurationSeconds.value
            }
          })
        } else {
          delete $scope.uiSettings.driverIdentification
        }
        delete $scope.uiSettings.driverPrompt
        delete $scope.uiSettings.audioAlert
        delete $scope.uiSettings.driverPromptDurationSeconds
        $scope.onSubmit()
      }
      $scope.onClose = function () {
        if (isNaN(Number($scope.uiSettings['standby'].value))) {
          $scope.uiSettings['standby'].value = $scope.initialStandbyValueFromApi
        }
        $scope.isStandbyClosed = false
      }

      $scope.showMessageToast = function (message) {
        var toast = $mdToast
          .simple()
          .textContent(message)
          .action($translate('ok'))
          .position('bottom')
          .hideDelay(5000)
          .actionKey('F1')
          .parent('#device-ui-settings-container')

        $mdToast
          .show(toast)
          .then(function (response) {})
          .catch(() => {})
      }
      $scope.showInvalidIntegerError = fieldName => {
        return $scope.showMessageToast(
          $translate('insertInteger') + $translate(fieldName)
        )
      }
      $scope.getNgValue = (settingObj, deviceAllSettings) => {
        const parentField = settingObj.parentFieldName
        const defaultValue = settingObj.defaultValue
        if (
          parentField &&
          deviceAllSettings[parentField] &&
          parentField !== 'driverPrompt'
        ) {
          return (
            deviceAllSettings[parentField][settingObj.valueFieldName] ||
            defaultValue
          )
        }
        if (settingObj.valueFieldName && deviceAllSettings[settingObj.name]) {
          return deviceAllSettings[settingObj.name][settingObj.valueFieldName]
        }

        return defaultValue || undefined
      }
      $scope.isAI14Device = window.isAI14Device($scope.serialNumber)
      $scope.isFieldEnabled = settingObj => {
        if (settingObj.enabledByDefault) {
          return true
        }
        const parentKeyName = settingObj.parentFieldName
        const parentValueName = settingObj.parentFieldValueName

        if (
          parentKeyName &&
          $scope.uiSettings[parentKeyName] &&
          parentValueName
        ) {
          const isActive = $scope.uiSettings[parentKeyName][parentValueName]
          if (!isActive && !settingObj.enabledByValueValidation) {
            if (!$scope.uiSettings[parentKeyName][settingObj.valueFieldName]) {
              $scope.uiSettings[parentKeyName][settingObj.valueFieldName] =
                settingObj.defaultValue
            }
          }
          return isActive
        }
        return false
      }
      $scope.$watch('uiSettings', () => {
        if ($scope.uiSettings['standby']) {
          if (
            $scope.initialStandbyValueFromApi === undefined &&
            $scope.uiSettings['standby'].value !== undefined &&
            $scope.uiSettings['standby'].value !== null
          ) {
            $scope.initialStandbyValueFromApi =
              $scope.uiSettings['standby'].value
          }
          $scope.uiSettingFields.forEach(uiSettingField => {
            if (uiSettingField.name === 'standby') {
              if (
                !uiSettingField.allowedValues.find(
                  allowedValue =>
                    allowedValue.value === $scope.uiSettings['standby'].value
                )
              ) {
                uiSettingField.allowedValues.push({
                  title: $scope.uiSettings['standby'].value,
                  value: Number($scope.uiSettings['standby'].value),
                  custom: true
                })
                $scope.customValueForStandby =
                  $scope.uiSettings['standby'].value
              }
            }
          })
        }
        if (
          (($scope.uiSettings.pinCodeDi && $scope.uiSettings.pinCodeDi.value) ||
            ($scope.uiSettings.qrDi && $scope.uiSettings.qrDi.value)) &&
          $scope.uiSettings.driverIdentification
        ) {
          $scope.uiSettings.driverPrompt = {
            value:
              $scope.uiSettings.driverIdentification &&
              $scope.uiSettings.driverIdentification.driverPrompt
          }
          $scope.uiSettings.audioAlert = {
            value:
              $scope.uiSettings.driverIdentification &&
              $scope.uiSettings.driverIdentification.audioAlert
          }
          if (
            $scope.uiSettings.driverIdentification &&
            $scope.uiSettings.driverIdentification.driverPrompt
          ) {
            let driverPromptDurationSeconds =
              $scope.uiSettings.driverIdentification &&
              $scope.uiSettings.driverIdentification.driverPromptDurationSeconds
            $scope.uiSettings.driverPromptDurationSeconds = {
              value: driverPromptDurationSeconds
            }
          }
        }
        if (
          $scope.uiSettings.recordingEncryption &&
          !$scope.initialRecordingEncryptionSetting
        ) {
          $scope.initialRecordingEncryptionSetting = {
            ...$scope.uiSettings.recordingEncryption
          }
        }
        if (
          ($scope.uiSettings.pinCodeDi || $scope.uiSettings.qrDi) &&
          !$scope.initialDriverIdentificationSetting
        ) {
          $scope.driverIdentificationSetting.value =
            $scope.uiSettings.pinCodeDi && $scope.uiSettings.pinCodeDi.value
              ? 'pin'
              : $scope.uiSettings.qrDi && $scope.uiSettings.qrDi.value
              ? 'qr'
              : 'off'
        }
      })
      $scope.showBulkPrivacyModeForm = () => {
        $scope.onShowPrivacyModeForm()
      }

      $scope.generateRecordingEncryptionPassword = () => {
        const requestJson = {
          method: 'PUT',
          url: `${V2_BASEURL}/generate-encryption-key`,
          data: {}
        }
        $http(requestJson)
          .then(result => {
            const { key } = result.data
            $scope.uiSettings.recordingEncryption.password = key
          })
          .catch(error => {
            const errorMessage =
              (error.data && error.data.message) ||
              (error.data && error.data.status && error.data.status.error) ||
              'Failed to generate recording encryption key'
            $scope.showMessageToast(errorMessage)
          })
      }

      $scope.showPasswordRules = false
      $scope.togglePasswordRules = () => {
        $scope.showPasswordRules = !$scope.showPasswordRules
      }

      $scope.showPassword = false
      $scope.togglePasswordVisibility = () => {
        $scope.showPassword = !$scope.showPassword
      }

      $scope.isRestrictedUser =
        $localStorage.userDetails.accessLevel === 'viewer'

      $scope.showPinManagement = () => {
        $scope.pinManagementVisible = true
      }

      $scope.authorizePinManagement = async () => {
        $scope.fetchPinCodes()
      }

      $scope.hidePinManagement = () => {
        $scope.pinForm = {
          userPassword: '',
          adminPin: '',
          driverPin: ''
        }
        $scope.showPin = {
          adminPin: false,
          driverPin: false
        }
        $scope.isAuthorizedForPinManagement = false
        $scope.pinManagementVisible = false
      }

      $scope.fetchPinCodes = async () => {
        if ($scope.isOrgDeviceSettings) {
          try {
            const response = await $http.post(
              `${V2_BASEURL}/organizations/${$scope.organizationId}/default-settings/pin-codes`,
              {
                password: $scope.pinForm.userPassword
              }
            )

            $scope.pinForm.adminPin = response.data.data.adminPin.value
            $scope.pinForm.driverPin = response.data.data.driverPin.value
            $scope.isAuthorizedForPinManagement = true
          } catch (error) {
            return $scope.showMessageToast($translate(error.data.message))
          }
        } else if ($scope.imei) {
          try {
            const response = await $http.post(
              `${V2_BASEURL}/devices/${$scope.imei}/pin-codes`,
              {
                password: $scope.pinForm.userPassword
              }
            )

            $scope.pinForm.adminPin = response.data.data.adminPin.value
            $scope.pinForm.driverPin = response.data.data.driverPin.value
            $scope.isAuthorizedForPinManagement = true
          } catch (error) {
            return $scope.showMessageToast($translate(error.data.message))
          }
        }

        $scope.originalPins = {
          adminPin: $scope.pinForm.adminPin,
          driverPin: $scope.pinForm.driverPin
        }
      }

      $scope.togglePinVisibility = pinType => {
        $scope.showPin[pinType] = !$scope.showPin[pinType]
      }

      $scope.setNewPinCodes = async () => {
        $scope.uiSettings.driverPin.value = $scope.pinForm.driverPin
        $scope.uiSettings.adminPin.value = $scope.pinForm.adminPin
        $scope.hidePinManagement()
      }

      $scope.discardPinChanges = () => {
        $scope.hidePinManagement()
      }

      function normalizePin (v) {
        return (v == null ? '' : String(v)).replace(/\D/g, '').slice(0, 4)
      }

      $scope.pinsUnchanged = function () {
        return (
          normalizePin($scope.pinForm.adminPin) ===
            $scope.originalPins.adminPin &&
          normalizePin($scope.pinForm.driverPin) ===
            $scope.originalPins.driverPin
        )
      }

      $scope.fourDigitPattern = /^\d{4}$/

      $scope.sanitizePin = function (field, maxLen) {
        if (!$scope.pinForm) $scope.pinForm = {}
        var v = $scope.pinForm[field]
        if (v == null) return
        v = $scope.normalizePin(v)
        if (maxLen) v = v.slice(0, maxLen)
        $scope.pinForm[field] = v
      }

      $scope.onUserPasswordKeydown = function ($event) {
        if ($event.key === 'Enter' || $event.keyCode === 13) {
          $event.preventDefault()
          $event.stopPropagation()
          $scope.authorizePinManagement()
        }
      }
    }
  ])
